<template>
  <div v-if="deliverable">
    <div class="pb-0 titles exclude-outside-click" v-show="!addDepartmentFlag" @click="showAddDepartment">
      <div
        class="department-title exclude-outside-click"
        v-for="(department, index) in deliverable.departments"
        :key="'deliverable-modal-department-'+department.id"
      >
        <span class="department--separator" v-if="index > 0">&nbsp;&</span> {{ department.name }}
      </div>
      <div class="department-title exclude-outside-click" v-show="!hasDepartments()">No Department</div>
      <plus-button class="tagged-departments"/>
    </div>
    <multiselect
      ref="deliverableDepartments"
      v-click-outside="outside"
      v-show="addDepartmentFlag"
      v-model="deliverable.departments"
      :close-on-select="true"
      :options="allActiveDepartments"
      :show-labels="false"
      :multiple="true"
      :taggable="false"
      label="name"
      track-by="id"
      :id="deliverable.deliverableId"
      @input="updateProjectFieldValue(deliverable)"
      @close="addDepartmentFlag=false"
    ></multiselect>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["deliverable"],
  data() {
    return {
      addDepartmentFlag: false
    };
  },
  computed: {
    ...mapGetters(["allDepartments", "allActiveDepartments", "userAbilities"]),
    userCanEditProject() {
			const userId = localStorage.getItem("userId");
      const project = this.deliverable;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
		},
  },
  methods: {
    ...mapActions(["updateProjectFieldValue"]),
    hasDepartments() {
      if (this.deliverable) {
        if (this.deliverable.departments) {
          if (this.deliverable.departments.length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    showAddDepartment() {
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly || !this.userCanEditProject) return;
      this.addDepartmentFlag = true
      this.$nextTick(() => {
        this.$refs.deliverableDepartments.$el.focus()
      })
    },
    outside() {
      this.$set(this, "addDepartmentFlag", false);
    }
  }
};
</script>

<style>
</style>